// Day numbers (days since 1970-01-01) as text, the way the prototype wrote them.
const DAY = 864e5;
export const fmtDay = (n: number, withYear = false) =>
  new Date(n * DAY).toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC', ...(withYear ? { year: 'numeric' } : {}) });
export const inDays = (n: number) => (n === 0 ? 'today' : n === 1 ? 'tomorrow' : 'in ' + n + ' days');
export const spanText = (o: { start: number; end: number }) => (o.start === o.end ? fmtDay(o.start) : fmtDay(o.start) + ' – ' + fmtDay(o.end));
